// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__hBDWK","logo":"Footer_logo__kV25H"};